import React from 'react';

import GeoLocationPermissionBanner from 'flow/components/GeoLocationPermissionBanner';
import GeoOutsideFenceBanner from 'flow/components/GeoOutsideFenceBanner';
import { useAppSelector } from 'flow/hooks/useRedux';
import {
    selectIsOutsideFence,
    selectPositionIsUnavailable,
} from 'flow/selectors/geolocation-selectors';

const GeoLocationNotifier = () => {
    const positionIsUnavailable = useAppSelector(selectPositionIsUnavailable);
    const isOutsideFence = useAppSelector(selectIsOutsideFence);

    if (positionIsUnavailable) {
        return <GeoLocationPermissionBanner />;
    }

    return isOutsideFence ? <GeoOutsideFenceBanner /> : null;
};

export default GeoLocationNotifier;
